export type FlightTone = 'good' | 'bad' | 'unknown';

/** Green when FlightAware is not blocking the tail, red when blocked, grey when unknown. */
export function flightTone(status: string | undefined): FlightTone {
  if (status === 'available') return 'good';
  if (status === 'blocked') return 'bad';
  return 'unknown';
}

export function flightLabel(status: string | undefined): string {
  if (status === 'available') return 'Retrievable';
  if (status === 'blocked') return 'Blocked';
  if (status === 'unavailable') return 'Not available';
  return 'Unknown';
}
